import React, { useEffect } from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import LogService from '../../services/log.service';
import PatientReportVideo from '../patientReportVideo/PatientReportVideo';

const useStyles = makeStyles((theme) => {
  return {
    title: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: '500',
      lineHeight: '27px',
      [theme.breakpoints.up('md')]: {
        fontSize: '24px',
        lineHeight: '36px',
      },
    },
    videoContainer: {
      marginTop: '16px',
    },
  };
});

export default ({ videoData, resourceId }) => {
  const classes = useStyles();

  useEffect(() => {
    new LogService().userReportLinkUsed(resourceId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Typography className={classes.title} style={{ fontWeight: '500' }} align="left">
        Shared Video Report
      </Typography>

      <div className={classes.videoContainer}>
        <PatientReportVideo video={videoData || {}} />
      </div>
    </div>
  );
};
